export var PAYMENT_URL = '/api/v1/payment/pay';
export var REGISTER_URL = '/api/v1/payment/register';
export var GET_STATE_URL = '/api/v1/payment/getState';
export var STATUS_URL = '/api/v1/payment/pay/status';
export var DEFAULT_INTERVAL = 1000;
export var ERegisterStatus = /*#__PURE__*/function (ERegisterStatus) {
  ERegisterStatus["SmsCode"] = "smsCode";
  ERegisterStatus["IncorrectSmsCode"] = "incorrectSmsCode";
  ERegisterStatus["CheckSmsMaxAttempts"] = "checkSmsCodeMaxAttempts";
  ERegisterStatus["SendSmsCodeMaxAttempts"] = "sendSmsCodeMaxAttempts";
  ERegisterStatus["SmsCodeExpired"] = "smsCodeExpired";
  return ERegisterStatus;
}({});
export var ECommonStatus = /*#__PURE__*/function (ECommonStatus) {
  ECommonStatus["Success"] = "success";
  ECommonStatus["Error"] = "error";
  ECommonStatus["ServerError"] = "ServerError";
  ECommonStatus["Process"] = "process";
  return ECommonStatus;
}({});
export var EPaymentStatus = /*#__PURE__*/function (EPaymentStatus) {
  EPaymentStatus["Provide"] = "smsCode";
  EPaymentStatus["LimitExceeded"] = "maxSmsCode";
  EPaymentStatus["ErrorSMSCode"] = "errorSmsCode";
  return EPaymentStatus;
}({});
export var EPollStatus = /*#__PURE__*/function (EPollStatus) {
  EPollStatus["Process"] = "process";
  return EPollStatus;
}({});